import { useAtom, useSetAtom, useAtomValue } from "jotai";
import {
  labelsAtom,
  inputTextSearchAtom,
  toolsExperienceAtom,
  toolsExperienceOptionViewsAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  forGratificationAtom,
  hardSkillsAtom,
  requiredAreaOfExpertiseAtom,
  projectDeadlineAtom,
  softSkillsAtom,
  offeredWorkingTypeAtomNewArray,
  offeredWorkingTypeActiveOptionsAtom,
  usedLanguagesAtom,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  locationsAtom,
  openAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  productTypeAtom
} from "./atom/TeammateFiltersAtom";

import "../../sass/components/ProjectFilters/Layout.scss";
import ToolsExperienceFilter from "../Filters_Teammates/ToolsExperienceFilter";
import ProjectType from "../Filters_Teammates/ProjectTypeFilter";
import OfferredGratification from "../Filters_Teammates/OfferedGratificationFilter";
import ForGratification from "../Filters_Teammates/ForGratificationFilter";
import AreaOfExperties from "../Filters_Teammates/AreaOfExpertiesFilter";
import ProjectDeadline from "../Filters_Teammates/ProjectDeadlineFilter";
import OfferedWorkingType from "../Filters_Teammates/OfferedWorkingTypeFilter";
import Availability from "../Filters_Teammates/RequiredAvailabilityFilter";
import BizOrTechRole from "../Filters_Teammates/RequiredBizOrTechRoleFilter";
import ProductTypeFilter from '../Filters_Teammates/ProductTypeFilter';
import { Button } from "@mui/material";
import { useDataFromTeammateFilters } from "../../utils/useDataFromTeammateFilters";
import { url } from "../../url";
import axios from "axios";
import tools_tools from "../../data/projects/enums/projects_tools_tools";
import { teammatesAtom } from "../../pages/Teammate/atoms/TeammateAtomGlobal";
import {useOpenCloseFiltersFromTeammateFilters} from "../../utils/useOpenCloseFiltersFromTeammateFilters";
import { HardSkillsFilter, SoftSkillsFilter, LocationFilter, UsedLanguagesFilter } from "../common";
import { FILTERS } from '../../filters/filtersConfig';

interface TeammateFiltersProps {
  onDisplayJson?: (jsonData: any) => void;
  onCloseFilters?: () => void;
}

const TeammateFilters = ({ onDisplayJson, onCloseFilters }: TeammateFiltersProps) => {
  const [labels, setLabels] = useAtom(labelsAtom);  // Store predicted labels
  const [inputTextSearch, setInputTextSearch] = useAtom(inputTextSearchAtom);  // Search text input
  
  const handleSearch = async () => {
    if (inputTextSearch.trim() !== "") {
      try {

        //  LOCAL
        // const response = await axios.post(url_predict + "/predict", {
        //   input_text: inputTextSearch,
        //   len_2_cnt: 2
        // });

        // DEPLOY
        const response = await axios.post(url + "/ml", {
          input_text: inputTextSearch,
          len_2_cnt: 2
        });
        
        const result = response.data.similar_labels_dict;
        setLabels(result);  // Store full response for display
        
        // NEW: Update filters dynamically with API response
        updateFilters(result);
  
        console.log("Predicted Labels Dict:", result);
      } catch (error) {
        console.error('Error fetching predictions:', error);
      }
    }
  };
  
  // NEW: Map API response to filter atoms
  const updateFilters = (result: Record<string, string[]>) => {
    const filterMapping: Record<string, any> = {
      toolsExperience: setToolsExperience,
      projectType: setProjectType,
      hardSkills: setHardSkills,
      softSkills: setSoftSkills,
      requiredAreaOfExpertise: setRequiredAreaOfExpertise,
      offeredGratification: setOfferedGratification,
      forGratification: setForGratification,
      usedLanguages: setUsedLanguages,
      locations: setLocations,
      productType: setProductType,
    };
  
    Object.entries(result).forEach(([key, values]) => {
      if (filterMapping[key]) {
        console.log(`Updating ${key} with`, values);  // Debug
        filterMapping[key]((prev: string[]) => [...values]);  // Spread to trigger re-render
      } else {
        console.warn(`No atom found for key: ${key}`);  // Warn if unmapped key
      }
    });
  };



  const [toolsExperience, setToolsExperience] = useAtom(toolsExperienceAtom);
  const [toolsExperienceOptionViews, setToolsExperienceOptionViews] = useAtom(
    toolsExperienceOptionViewsAtom,
  );
  const [projectType, setProjectType] = useAtom(projectTypeAtom);
  const [offeredGratification, setOfferedGratification] = useAtom(
    offeredGratificationAtom,
  );
  const [hardSkills, setHardSkills] = useAtom(
    hardSkillsAtom,
  );
  const [requiredAreaOfExpertise, setRequiredAreaOfExpertise] = useAtom(
    requiredAreaOfExpertiseAtom,
  );
  const [forGratification, setForGratification] = useAtom(forGratificationAtom);
  const [projectDeadline, setProjectDeadline] = useAtom(projectDeadlineAtom);
  const [softSkills, setSoftSkills] = useAtom(softSkillsAtom);
  const [offeredWorkingTypeNewArray, setOfferedWorkingTypeNewArray] = useAtom(
    offeredWorkingTypeAtomNewArray,
  );
  const [offeredWorkingTypeActiveOptions, setOfferedWorkingTypeActiveOptions] =
    useAtom(offeredWorkingTypeActiveOptionsAtom);
  const [usedLanguages, setUsedLanguages] = useAtom(usedLanguagesAtom);
  const [requiredAvailability, setRequiredAvailability] = useAtom(requiredAvailabilityAtomStartValue);
  const [requiredAvailabilityEndValue, setRequiredAvailabilityEndValue] =
    useAtom(requiredAvailabilityAtomEndValue);
  const [requiredAvailabilityOption, setRequiredAvailabilityOption] = useAtom(
    requiredAvailabilityAtomOption,
  );
  const [locations, setLocations] = useAtom(locationsAtom);
  const [bizOrTechRoleLeftValue, setBizOrTechRoleLeftValue] = useAtom(bizOrTechRoleAtomLeftValue);
  const [bizOrTechRoleRightValue, setBizOrTechRoleRightValue] = useAtom(bizOrTechRoleAtomRightValue);
  const [productType, setProductType] = useAtom(productTypeAtom);

  const openFilters = useAtomValue(openAtom);
  const enableAndResetFilters = useOpenCloseFiltersFromTeammateFilters();

  const setTeammates = useSetAtom(teammatesAtom);
  const query = useDataFromTeammateFilters();

  const applyFilters = async () => {
    console.log("=== APPLY BUTTON CLICKED (TeammateFilters) ===");
    // Buduj activeFilters analogicznie jak w projektach
    const activeFilters: any = {};
    if (toolsExperience.length > 0) activeFilters.toolsExperience = toolsExperience;
    if (projectType.length > 0) activeFilters.projectType = projectType;
    if (offeredGratification.length > 0) activeFilters.offeredGratification = offeredGratification;
    if (forGratification.length > 0) activeFilters.forGratification = forGratification;
    if (softSkills.length > 0) activeFilters.softSkills = softSkills;
    if (requiredAreaOfExpertise.length > 0) activeFilters.requiredAreaOfExpertise = requiredAreaOfExpertise;
    if (projectDeadline && new Date(projectDeadline) > new Date('1970-01-01')) activeFilters.projectDeadline = projectDeadline;
    if (hardSkills.length > 0) activeFilters.hardSkills = hardSkills;
    if (offeredWorkingTypeNewArray.length > 0) activeFilters.offeredWorkingType = offeredWorkingTypeNewArray;
    if (offeredWorkingTypeActiveOptions.length > 0) activeFilters.offeredWorkingTypeActiveOptions = offeredWorkingTypeActiveOptions;
    if (usedLanguages.length > 0) activeFilters.usedLanguages = usedLanguages;
    if (locations.length > 0) activeFilters.locations = locations;
    if (bizOrTechRoleLeftValue.length > 0) activeFilters.bizOrTech = [bizOrTechRoleLeftValue, bizOrTechRoleRightValue];
    if (productType.length > 0) {
      activeFilters.productType = productType;
      activeFilters.product_type = productType;
    }
    if (requiredAvailability > 0) activeFilters.requiredAvailability = requiredAvailability;
    console.log("Query:", activeFilters);
    try {
      // 1. TRADITIONAL FILTERING
      const res = await axios.post(url + "/teammate/traditional_filtering", {
        activeFilters: activeFilters,
        filtering_restriction: "min_1_match"
      }, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("TRADITIONAL FILTERING RESULT:", res.data);
      const teammates = res.data.teammates || [];
      if (teammates.length > 0) {
        if (onDisplayJson) {
          onDisplayJson(res.data);
        } else {
          setTeammates(teammates);
        }
        return;
      }
      // 2. MAGIC SORT jeśli brak wyników
      let filter = { ...activeFilters };
      if (!filter || typeof filter !== 'object' || Array.isArray(filter)) {
        filter = {};
      }
      if (filter.projectDeadline instanceof Date) {
        filter.projectDeadline = filter.projectDeadline.toISOString();
      }
      // ZAMIANA: fetch bezpośrednio do Flask
      const aiRes = await fetch("https://embedding-api-dot-smart-setting-448914-d9.lm.r.appspot.com/sort", { // TODO Change urls for prod in .env
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "teammate", filter }),
      }).then(res => res.json());
      // Pobierz wszystkich teammates, żeby dopasować po _id
      const allTeammatesRes = await axios.get(url + "/teammate");
      const allTeammatesData = allTeammatesRes.data;
      const sortedTeammates = (aiRes.results || []).map((result: any) => {
        const teammate = allTeammatesData.teammates.find((t: any) => t._id === result.record_id);
        if (!teammate) return null;
        return { ...teammate, similarity: result.similarity };
      }).filter(Boolean);
      if (onDisplayJson) {
        onDisplayJson({ teammates: sortedTeammates });
      } else {
        setTeammates(sortedTeammates);
      }
    } catch (error) {
      console.error("Traditional filtering error:", error);
      // Fallback do klasycznego filtrowania (GET)
      const res = await axios.get(url + "/teammate?page=1", {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (onDisplayJson) {
        onDisplayJson(res.data);
      } else {
        setTeammates(res.data.teammates);
      }
    }
    console.log("=== END APPLY BUTTON LOG (TeammateFilters) ===");
  };

  const clearFilters = async () => {
    setToolsExperience([]);
    setToolsExperienceOptionViews(
      tools_tools.reduce((acc: any, option: string) => {
        acc[option] = 1; // Initialize views for each option to 1
        return acc;
      }, {}),
    );
    setProjectType([]);
    setOfferedGratification([]);
    setHardSkills([]);
    setRequiredAreaOfExpertise([]);
    setForGratification([]);
    setProjectDeadline(new Date(0));
    setSoftSkills([]);
    setOfferedWorkingTypeNewArray([]);
    setOfferedWorkingTypeActiveOptions([]);
    setUsedLanguages([]);
    setRequiredAvailability(0);
    setRequiredAvailabilityEndValue(0);
    setRequiredAvailabilityOption("");
    setLocations([]);
    setBizOrTechRoleLeftValue([]);
    setBizOrTechRoleRightValue([]);
    setInputTextSearch("");
    setProductType([]);

    const res = await axios.get(url + "/teammate?page=1", {
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Użyj displayJson jeśli dostępne, w przeciwnym razie użyj setTeammates
    if (onDisplayJson) {
      onDisplayJson(res.data);
    } else {
      setTeammates(res.data.teammates);
    }
  };

  return (
    <div className="projects__body__container__left__card">
      <div className="filter-content">
        <div className='filter-container'>
          <div className="search-bar-container">
            <input
              type="text"
              value={inputTextSearch}
              onChange={(e) => setInputTextSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();  // Trigger search on Enter
              }}
              placeholder="Write what you want to build, who do you need, what skills, whatever..."
            />
            <button onClick={handleSearch}>Adjust Filters</button>
          </div>
        </div>
      </div>
      <div className="filter-container">
        {/* 1. Product Type */}
        <div className={`filter-box-container ${productType.length > 0 ? 'selected' : ''}`}>
          <ProductTypeFilter
            pickedOptions={productType}
            setPickedOptions={setProductType}
            show={openFilters.productType}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.productType.label}
          />
        </div>

        {/* 2. Project Type */}
        <div className={`filter-box-container ${projectType.length > 0 ? 'selected' : ''}`}>
          <ProjectType
            pickedOptions={projectType}
            setPickedOptions={setProjectType}
            show={openFilters.projectType}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.projectType.label}
          />
        </div>

        {/* 3. Area of Expertise */}
        <div className={`filter-box-container ${requiredAreaOfExpertise.length > 0 ? 'selected' : ''}`}>
          <AreaOfExperties
            pickedOptions={requiredAreaOfExpertise}
            setPickedOptions={setRequiredAreaOfExpertise}
            show={openFilters.requiredAreaOfExpertise}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.industry.label}
          />
        </div>

        {/* 4. Hard Skills */}
        <div className={`filter-box-container ${hardSkills.length > 0 ? 'selected' : ''}`}>
          <HardSkillsFilter
            pickedOptions={hardSkills}
            setPickedOptions={setHardSkills}
            show={openFilters.hardSkills}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.hardSkills.label}
          />
        </div>

        {/* 5. Soft Skills */}
        <div className={`filter-box-container ${softSkills.length > 0 ? 'selected' : ''}`}>
          <SoftSkillsFilter
            pickedOptions={softSkills}
            setPickedOptions={setSoftSkills}
            show={openFilters.softSkills}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.softSkills.label}
          />
        </div>

        {/* 6. Tools Experience */}
        <div className={`filter-box-container ${toolsExperience.length > 0 ? 'selected' : ''}`}>
          <ToolsExperienceFilter
            pickedOptions={toolsExperience}
            setPickedOptions={setToolsExperience}
            optionViews={toolsExperienceOptionViews}
            setOptionViews={setToolsExperienceOptionViews}
            show={openFilters.toolsExperience}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.toolsExperience.label}
          />
        </div>

        {/* 7. Used Languages */}
        <div className={`filter-box-container ${usedLanguages.length > 0 ? 'selected' : ''}`}>
          <UsedLanguagesFilter
            pickedOptions={usedLanguages}
            setPickedOptions={setUsedLanguages}
            show={openFilters.usedLanguages}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.usedLanguages.label}
          />
        </div>

        {/* 8. Location */}
        <div className={`filter-box-container ${locations.length > 0 ? 'selected' : ''}`}>
          <LocationFilter 
            pickedOptions={locations} 
            setPickedOptions={setLocations} 
            show={openFilters.locations}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.locations.label}
          />
        </div>

        {/* 9. Required Availability */}
        <div className={`filter-box-container ${requiredAvailability || requiredAvailabilityEndValue  ? 'selected' : ''}`}>
          <Availability
            value={requiredAvailability}
            setValue={setRequiredAvailability}
            open={openFilters.requiredAvailability}
            setOpen={enableAndResetFilters}
            title={FILTERS.requiredAvailability.label}
          />
        </div>

        {/* 10. Offered Working Type */}
        <div className={`filter-box-container ${offeredWorkingTypeNewArray.length > 0 ? 'selected' : ''}`}>
          <OfferedWorkingType
            activeOptions={offeredWorkingTypeActiveOptions}
            setActiveOptions={setOfferedWorkingTypeActiveOptions}
            newArray={offeredWorkingTypeNewArray}
            setNewArray={setOfferedWorkingTypeNewArray}
            show={openFilters.offeredWorkingType}
            setShow={enableAndResetFilters}
            title={FILTERS.offeredWorkingType.label}
          />
        </div>

        {/* 11. Project Deadline */}
        <div className={`filter-box-container ${projectDeadline && new Date(projectDeadline) > new Date('1970-01-01') ? 'selected' : ''}`}>
          <ProjectDeadline
            dateState={projectDeadline}
            setDateState={setProjectDeadline}
            open={openFilters.projectDeadline}
            setOpen={enableAndResetFilters}
            title={FILTERS.projectDeadline.label}
          />
        </div>

        {/* 12. Offered Gratification */}
        <div className={`filter-box-container ${offeredGratification.length > 0 ? 'selected' : ''}`}>
          <OfferredGratification
            pickedOptions={offeredGratification}
            setPickedOptions={setOfferedGratification}
            show={openFilters.offeredGratification}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.offeredGratification.label}
          />
        </div>

        {/* 13. For Gratification */}
        <div className={`filter-box-container ${forGratification.length > 0 ? 'selected' : ''}`}>
          <ForGratification
            pickedOptions={forGratification}
            setPickedOptions={setForGratification}
            show={openFilters.forGratification}
            setShow={enableAndResetFilters}
            displayColumn={true}
            title={FILTERS.forGratification.label}
          />
        </div>

        {/* BizOrTechRole zakomentowany, nie ruszam */}
      </div>
      <div className="spacer" />
      <div className='filter_buttons'>
        <Button onClick={() => {applyFilters()}} className="apply_button">Apply</Button>
        <Button onClick={clearFilters} className="clear_filters">Clear Filters</Button>
      </div>
    </div>
  );
};

export default TeammateFilters;
